export const TABLE_TYPES = {
    SQUARE: "SQUARE",
    RECTANGLE: "RECTANGLE",
    OVAL: "OVAL",
    ROUND: "ROUND",  
}

export const TABLE_TYPES_LABELS = {
    [TABLE_TYPES.SQUARE]: "Carrée",
    [TABLE_TYPES.RECTANGLE]: "Rectangulaire",
    [TABLE_TYPES.OVAL]: "Ovale",
    [TABLE_TYPES.ROUND]: "Ronde",  
};

export const TABLE_TYPE_OPTIONS = Object.entries(TABLE_TYPES_LABELS)
    .map(([value, text]) => ({
        key: value,
        value,
        text,
    }));

// legacy
export const tableTypeText = TABLE_TYPES_LABELS;


// WEBPACK FOOTER //
// ./src/constants/tables.js